import  io  from 'socket.io-client'
import { feedsenseApi } from '../api/axios'

const socket=io(feedsenseApi,{transports:['websocket']})
export default socket